import CreditSVG from "@/../../hypetrain/static/img/credit.svg";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";

import { pluralize } from "@/components/helpers/string-utils";
import EmbedSvg from "@/components/helpers/ui/EmbedSvg";
import { RichContentRenderer } from "@/components/helpers/ui/RichContentRenderer";
import { Box, Flex } from "@/components/layout/flexbox";

export default function ProductDetails({
  product,
  creditPrice = null,
  hideCost = false,
}) {
  return (
    <DetailGrid mx={[2, 0]} mt={24} pt={24} className="bts">
      {!hideCost && product.category === "GROUP_MEETING" ? (
        <>
          <Box fontWeight={500}>What to Expect</Box>
          <Box>
            <Link to={`/explore/${product.slug}`}>
              Learn more about this service
            </Link>
          </Box>
        </>
      ) : null}
      {!hideCost && (creditPrice || product.displayedCreditPrice) ? (
        <>
          <Box fontWeight={500}>Cost</Box>
          <Box>
            <EmbedSvg src={CreditSVG} height={18} width={18} />{" "}
            {pluralize(
              creditPrice || product.displayedCreditPrice,
              "credit",
              "credits",
              true,
            )}
          </Box>
        </>
      ) : null}
      {product.duration ? (
        <>
          <Box fontWeight={500}>Duration</Box>
          <Box>{product.duration} mins</Box>
        </>
      ) : null}
      {["MEETING", "GROUP_MEETING"].includes(product.category) ? (
        <>
          <Box fontWeight={500}>Location</Box>
          <Box>Virtual Meeting</Box>
        </>
      ) : null}
      {product.description ? (
        <>
          <Box fontWeight={500}>Description</Box>
          <Box>
            <StyledDescription
              flex={1}
              minWidth={250}
              maxWidth={640}
              flexDirection="column"
            >
              <RichContentRenderer content={product.description} />
            </StyledDescription>
          </Box>
        </>
      ) : null}
      {product.numRounds ||
      product.includesFinalCheck ||
      product.turnaroundTime ? (
        <>
          <Box fontWeight={500}>Details</Box>
          <Box>
            <ul style={{ paddingLeft: 16 }}>
              {product.numRounds ? (
                <li>
                  {pluralize(product.numRounds, "round", "rounds")} of in-depth
                  review
                </li>
              ) : null}
              {product.includesFinalCheck ? (
                <li>Includes a final check</li>
              ) : null}
              {product.turnaroundTime ? (
                <li>{product.turnaroundTime} business day turnaround time</li>
              ) : null}
            </ul>
          </Box>
        </>
      ) : null}
    </DetailGrid>
  );
}

const StyledDescription = styled(Flex)`
  p:last-child {
    margin-bottom: 0;
  }
  @media screen and (max-width: 425px) {
    p,
    ul {
      word-break: break-word;
      white-space: normal;
    }
  }
`;

const DetailGrid = styled(Box)`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 24px;
`;
